module.exports = __webpack_public_path__ + "media/Video 108.3fe469fb.mp4";